export default __webpack_public_path__ + "static/increase-conversion-rate-3b000bc630b0114c25532a686147afdf.svg";